import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import zh from './zh.json';
import pt from './pt.json';
import th from './th.json';
import tw from './tw.json';
import ar from './ar.json';
import vn from './vn.json';

export const canUseLanguages = ['zh', 'tw', 'en', 'pt', 'th', 'ar', 'vn'];
const rtlLanguages = ['ar']; // 可再加 'he', 'fa' 等

export const getUserLanguage = (useLocalStorage = true) => {
    if (useLocalStorage) {
        const localLanguage = localStorage.getItem('i18nextLng');

        if (localLanguage && canUseLanguages.find((item) => item === localLanguage)) {
            setLangDirect(localLanguage);
            return localLanguage;
        }
    }

    let language = window.navigator.userLanguage || window.navigator.language;

    if (language.indexOf('zh') !== -1) {
        if (language.indexOf('TW') !== -1 || language.indexOf('HK') !== -1) language = 'tw';
        else language = 'zh';
    } else {
        language = language.split('-')[0].toLowerCase();

        if (language === 'vi') language = 'vn';
    }

    if (!canUseLanguages.find((item) => item === language)) {
        language = 'en';
    }

    setLangDirect(language);

    return language;
};

const resources = {
    tw: {
        translation: tw,
    },
    zh: {
        translation: zh,
    },
    en: {
        translation: en,
    },
    pt: {
        translation: pt,
    },
    th: {
        translation: th,
    },
    ar: {
        translation: ar,
    },
    vn: {
        translation: vn,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: getUserLanguage(true),
    interpolation: {
        escapeValue: false,
    },
});

function setLangDirect(lng) {
    const isRtl = rtlLanguages.includes(lng);
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
    document.body.style.direction = isRtl ? 'rtl' : 'ltr';
}

i18n.on('languageChanged', (lng) => {
    setLangDirect(lng);
});

export default i18n;
